module.exports = __webpack_public_path__ + "img/icon7-1.88908a5c.svg";